module.exports = __webpack_public_path__ + "img/lianyungang.84c73f7.png";